// extracted by mini-css-extract-plugin
module.exports = {"inputDropdown":"collectionForm_inputDropdown__3Nkha","inputLabel":"collectionForm_inputLabel__27J4O"};